export default "__VITE_ASSET__C3UE1GCR__"